module.exports = __webpack_public_path__ + "img/com.liebherr.sdb.85f638b3.webp";